import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo } from 'react';
import LogoBar from './LogoBar/index.js';
import RightBar from './RightBar/index.js';
import { MainContainer } from '../../Container/index.js';
import { GridContainer, FlexContainer } from '../../CSS/index.js';
import { useWindowResize } from '../../Adaptability/index.js';
export const PrimaryFooter = memo(({ onTrackClick, disclosureLinks }) => {
    const { isMobileDevice } = useWindowResize();
    const ContainerComponent = isMobileDevice ? GridContainer : FlexContainer;
    return (_jsx("footer", { "data-cy": "footer", css: theme => css({
            padding: '24px 0 54px',
            color: theme.primaryDataColor,
            background: theme.primaryBackgroundColor,
            borderRadius: '15px 15px 0 0',
            boxShadow: '0 -4px 8px 0 rgba(0, 0, 0, 0.07)',
            '@media screen and (max-width: 768px)': {
                padding: '25px 0 30px'
            }
        }), children: _jsx(MainContainer, { children: _jsxs(ContainerComponent, { style: {
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gridTemplateColumns: '1fr 1fr',
                    gridTemplateAreas: `"logo logo" ". right"`
                }, children: [_jsx(LogoBar, {}), _jsx(RightBar, { links: disclosureLinks, onTrackClick: onTrackClick })] }) }) }));
});
//# sourceMappingURL=index.js.map